import { Component } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { GetMagicSetsResponse, MagicSet } from "@apiserver-rest/ponder-data-client-base";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { FormatDatePipe } from "@ponder-shared/pipes/format-date.pipe";
import { take } from "rxjs";

@Component({
    selector: "admin-magic-view-set",
    imports: [LoadingComponent, FormatDatePipe],
    templateUrl: "./admin-magic-view-set.component.html"
})
export class AdminMagicViewSet {
    public isLoading: boolean = true;
    public loadingSuccess: boolean = false;

    public selectedMagicSet!: MagicSet;
    private allMagicSets: MagicSet[] = [];
    public visibleMagicSets: MagicSet[] = [];

    public constructor(private ponderDataClient: PonderDataClient) {

    }

    public ngOnInit(): void {
        this.ponderDataClient
            .magicSetAll()
            .pipe(take(1))
            .subscribe({
                next: (response: GetMagicSetsResponse) => {
                    if (response.sets) {
                        this.allMagicSets = response.sets;
                        this.allMagicSets.sort((a, b) => {
                            var aTime = a.releaseDate.getTime();
                            var bTime = b.releaseDate.getTime();

                            if (aTime != bTime) {
                                return (bTime - aTime);                     // Newest first
                            } else {
                                return -a.code!.localeCompare(b.code!);     // Reverse alphabetical
                            }                                               // This is done so newest SLD is first as that is most likely why we are here.
                        });

                        this.visibleMagicSets = this.allMagicSets;
                        this.selectedMagicSet = this.visibleMagicSets[0];

                        this.loadingSuccess = true;
                    }
                }
            })
            .add(() => { this.isLoading = false; });
    }

    public onMagicSetFilterChange(value: string): void {
        value = value.toLowerCase().trim();

        if (value.length < 3) {
            this.visibleMagicSets = this.allMagicSets;
        }

        this.visibleMagicSets = this.allMagicSets.filter((set: MagicSet, index: number, array: MagicSet[]) => {
            return (set.name!.toLowerCase().indexOf(value) >= 0) || (set.code!.indexOf(value) >= 0);
        });

        if (this.visibleMagicSets.length) {
            this.onMagicSetSelected(this.visibleMagicSets[0].code!);
        }
    }

    public onMagicSetSelected(setCode: string): void {
        this.selectedMagicSet = this.visibleMagicSets.find((set: MagicSet, index: number, array: MagicSet[]) => {
            return set.code == setCode;
        })!;
    }
}